var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-horizontal-list',{attrs:{"items":_vm.items,"options":_vm.vhlOptions},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_vm._t("default",function(){return [_c('ItemCard',{attrs:{"showBookmarkAction":true,"showEditProjectIcon":false,"item":item}})]},{"item":item})]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }